import styled from "styled-components";

export const PnL = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: var(--fill-positive-bg, rgba(71, 89, 62, 0.72));
  backdrop-filter: blur(12px);
  padding: var(--spacing-space-4, 4px) var(--spacing-space-12, 12px);
  width: fit-content;
  margin: 0 auto;
  p.body {
    color: var(--text-positive, #45be33);
    font-variation-settings: "wght" 600;
  }
  &.negative {
    background: var(--fill-negative-bg);
    p.body {
      color: var(--text-negative);
    }
  }
`;

export const PlacePic = styled.img`
  display: block;
  width: 152px;
  height: 152px;
  object-fit: contain;
`;

export const PlacePicContainer = styled.div`
  display: block;
  width: fit-content;
  margin: 0 auto;
  position: relative;
`;

export const PlaceAbsolutePic = styled.img`
  position: absolute;
  width: 48px;
  height: 48px;
  object-fit: contain;
  top: -16px;
  right: -16px;
`;
